'use strict';

/*
  StaticContentful (LOAN-490)

  Drop-in replacement for the mogo-ui-lib `Contentful` class. Same constructor arguments and the
  same `getResource(resourceName, parameters, callback)` contract, but instead of calling the
  Contentful Delivery API it loads raw API responses that scripts/snapshot-contentful.js saved to
  app/content/snapshots/<environment_id>/ and passes them through the library's ContentfulParser,
  exactly as the original class did with a live response.

  Supported resources (the only ones ui_core uses):
    ENTRIES_FROM_MODEL          { model_id }             -> <env>/<model_id>.json
    ENTRIES_FROM_MODEL_BY_NAME  { model_id, name_value } -> <env>/<model_id>.json filtered on fields.name
    ENTRIES_FROM_MODEL_BY_ID    { model_id, name_value } -> <env>/<model_id>.json filtered on fields.id
    ENTRY                       { entry_id }             -> <env>/entry-<entry_id>.json

  Callback contract (unchanged): callback(flattenedData) on success, callback(null, httpStatus)
  on failure. Callbacks always fire asynchronously, as $.ajax did, so callers that set state
  after calling getResource() behave the same on a cache hit.
*/
function StaticContentful(config, params) {
  this._environmentId = params && params.environment_id || config && config.environment_id || 'master';
  this._verboseLevel = params && params.verboseLevel != null ? params.verboseLevel : 2;

  this.getResource = function (resourceName, parameters, callback) {
    var cb = typeof callback === 'function' ? callback : function () {};
    var request = StaticContentful.buildRequest(resourceName, parameters || {}, this._environmentId);
    var verboseLevel = this._verboseLevel;

    StaticContentful.loadSnapshot(request.url).done(function (raw) {
      var filtered = StaticContentful.filterItems(raw, request.match);
      setTimeout(function () {
        return cb(ContentfulParser.parseToFlatten(filtered, verboseLevel));
      }, 0);
    }).fail(function (xhr) {
      var status = xhr && xhr.status ? xhr.status : 0;
      console.error('StaticContentful: failed to load ' + request.url + ' (' + status + ')');
      setTimeout(function () {
        return cb(null, status);
      }, 0);
    });
  };
}

StaticContentful.BASE_URL = '/member/content/snapshots';
StaticContentful._cache = {};

StaticContentful.buildRequest = function (resourceName, parameters, environmentId) {
  var name = String(resourceName).toUpperCase();
  var file = null;
  var match = null;

  switch (name) {
    case 'ENTRIES_FROM_MODEL':
      file = parameters.model_id;
      break;
    case 'ENTRIES_FROM_MODEL_BY_NAME':
      file = parameters.model_id;
      match = { field: 'name', value: parameters.name_value };
      break;
    case 'ENTRIES_FROM_MODEL_BY_ID':
      file = parameters.model_id;
      match = { field: 'id', value: parameters.name_value };
      break;
    case 'ENTRY':
      file = parameters.entry_id ? 'entry-' + parameters.entry_id : null;
      break;
    default:
      throw new ReferenceError('StaticContentful: unsupported resource ' + resourceName);
  }

  if (!file || match && match.value == null) {
    throw new URIError('StaticContentful: missing parameter for ' + name);
  }
  return { url: StaticContentful.BASE_URL + '/' + environmentId + '/' + file + '.json', match: match };
};

// Returns a fresh copy so the parser never shares objects with the cached raw response.
StaticContentful.filterItems = function (raw, match) {
  var copy = JSON.parse(JSON.stringify(raw));
  if (!match) return copy;
  var items = (copy.items || []).filter(function (item) {
    return item.fields && item.fields[match.field] === match.value;
  });
  copy.items = items;
  copy.total = items.length;
  return copy;
};

StaticContentful.cacheBust = function () {
  // cache_bust_timestamp is a global set by app/views/layouts/layout.pug for every page.
  // eslint-disable-next-line camelcase
  return typeof cache_bust_timestamp !== 'undefined' ? cache_bust_timestamp : '';
};

StaticContentful.loadSnapshot = function (url) {
  if (!StaticContentful._cache[url]) {
    StaticContentful._cache[url] = $.getJSON(url + '?cb=' + StaticContentful.cacheBust()).fail(function () {
      delete StaticContentful._cache[url];
    });
  }
  return StaticContentful._cache[url];
};